module.exports = __webpack_public_path__ + "static/media/oberflex-freneolivier-2560x1440.fd062c7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-freneolivier-2560x1440.jpg
// module id = 1027
// module chunks = 37